const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function isAgentUuid(value: string | null | undefined): boolean {
  return UUID_RE.test((value ?? '').trim());
}

export function resolveAgentUuid(row: { uuid?: string | null } | null | undefined): string | null {
  const uuid = (row?.uuid ?? '').trim();
  return isAgentUuid(uuid) ? uuid : null;
}

export function agentDetailPath(row: { uuid?: string | null }): string[] | null {
  const uuid = resolveAgentUuid(row);
  return uuid ? ['/manage-agent', uuid] : null;
}
